// Footer.js
import React from "react";
import { Facebook, Instagram, Linkedin, Phone, Mail, Globe, MapPin } from "lucide-react";
import pic from '../pic.png';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section - Logo + Info */}
        <div className="footer-left ">
          <img
            src={pic} // replace with your logo path
            alt="Logo"
            className="footer-logo"
          />
          <p><MapPin size={16} /> Centre Urbain Nord BP 676 Tunis <br /> Tunis, Tunisia</p>
          <p><Phone size={16} /> +216 25 721 442</p>
          <p><Mail size={16} /> junior.entreprise.insat@gmail.com</p>
          <p><Globe size={16} /> www.jeinsat.tn</p>
        </div>

        {/* Middle Section - Links */}
        <div className="footer-middle">
          <ul>
            <li><a href="/">Accueil</a></li>
            <li><a href="/admin/projects">Projects</a></li>
            <li><a href="/admin/partners">Partenaires</a></li>
            <li><a href="/admin/collaborators">Collaboraterurs et articles</a></li>
            <li><a href="/admin/clients">Clients</a></li>
            <li><a href="/admin/users">Utilisateurs</a></li>
          </ul>
        </div>

        {/* Right Section - Socials */}
        <div className="footer-right">
          <p>Find us on social media</p>
          <div className="social-icons">
            <a href="#"><Facebook size={20} /></a>
            <a href="#"><Instagram size={20} /></a>
            <a href="#"><Linkedin size={20} /></a>
          </div>
        </div>
      </div>

      <h6 className="centered-h6">
        © 2025 Junior Entreprise Insat. Tous droits réservés.
      </h6>

    </footer>
  );
};

export default Footer;
